<button
  class="bg-[#005FFF]! rounded-sm! w-full! text-sm! tracking-[1.5px]!  {{
    buttonClass
  }}"
  matButton="filled"
  [disabled]="disabled"
  [type]="type"
  (click)="onClick()"
>
  {{ label }}
</button>
